import { Module } from "tabulator-tables";
import TomSelect from "tom-select";

class EditorModule extends Module {
  static moduleName = "editor";
  static moduleExtensions = {
    edit: {
      editors: {
        has_many_list: function (cell, onRendered, success, cancel, editorParams) {
          let cellValue = cell.getValue();
          let scrollHeight = 0;

          let input = null;
          const editor = document.createElement("select");
          editor.setAttribute("multiple", true);
          editor.style.display = "block";
          editor.style.padding = "2px";
          editor.style.height = "100%";
          editor.style.width = "100%";

          const options = Object.entries(editorParams)
            .sort((a, b) => a[1].localeCompare(b[1], undefined, { numeric: true }))
            .map(([key, value]) => ({
              value: key,
              text: value,
            }));

          onRendered(function () {
            input = new TomSelect(editor, {
              openOnFocus: true,
              allowEmptyOption: true,
              hideSelected: true,
              closeAfterSelect: true,
              options,
              items: cellValue,
              plugins: ["caret_position", "input_autogrow"],
            });

            input.on("change", function (e) {
              cell.getRow().normalizeHeight();
            });
            input.on("blur", onChange);
            input.on("keyup", function () {
              editor.style.height = "";

              const heightNow = editor.scrollHeight;

              editor.style.height = heightNow + "px";

              if (heightNow !== scrollHeight) {
                scrollHeight = heightNow;
                cell.getRow().normalizeHeight();
              }
            });
            input.control_input.addEventListener("keydown", function (e) {
              switch (e.key) {
                case "Enter":
                  if (e.shiftKey && input.dropdown.style.display === "none") {
                    onChange();
                  } else {
                    e.stopImmediatePropagation();
                    e.stopPropagation();
                  }

                  break;

                case "Escape":
                  cancel();

                  break;

                case "ArrowUp":
                case "ArrowDown":
                case "End":
                case "Home":
                  e.stopImmediatePropagation();
                  e.stopPropagation();
                  break;
                default:
                  cell.getRow().normalizeHeight();
              }
            });

            input.focus();
            cell.getRow().normalizeHeight();
          });

          function areArraysEqual(a, b) {
            if (a.length !== b.length) return false; // different sizes mean they are not equal
            return a.slice().sort().join() === b.slice().sort().join();
          }

          function onChange() {
            if (
              ((cellValue === null || typeof cellValue === "undefined") && input.getValue() !== "") ||
              !areArraysEqual(input.getValue(), cellValue)
            ) {
              if (success(input.getValue())) {
                cellValue = input.getValue();
              }

              setTimeout(function () {
                cell.getRow().normalizeHeight();
              }, 300);
            } else {
              cancel();
            }
          }

          return editor;
        },
      },
    },
  };
}

export { EditorModule };
